module.exports = "/static/assets/61602e599e63650a59b2a3d23b802307.png";